<template>
  <div class="media-card text-center d-flex flex-column h-100 position-relative" :class="{removable: removable, selected: selected, 'media-card--premium': showPremiumBanderole}">
    <template v-if="selected">
      <Icon icon="fa-pro-solid:circle-check" color="green" class="selected-icon" />
    </template>
    <div class="img-container position-relative d-flex flex-column justify-content-center">
      <div v-if="removable || draggable || editable" class="media-card__assignment-actions">
        <button
          v-if="draggable"
          type="button"
          class="media-card__assignment-action media-card__assignment-action--drag drag-handler"
          aria-label="Bild per Drag & Drop sortieren"
          title="Per Drag & Drop sortieren"
        >
          <Icon icon="fa-pro-solid:arrows-up-down-left-right" />
        </button>
        <button
          v-if="editable"
          type="button"
          class="media-card__assignment-action media-card__assignment-action--edit"
          aria-label="Medienangaben bearbeiten"
          title="Medienangaben bearbeiten"
          @click.stop="editAsset"
        >
          <Icon icon="fa-pro-solid:pen-to-square" />
        </button>
        <button
          v-if="removable"
          type="button"
          class="media-card__assignment-action media-card__assignment-action--remove"
          aria-label="Zuordnung aufheben"
          title="Zuordnung aufheben"
          @click.stop="unlinkAsset"
        >
          <Icon icon="fa-pro-solid:trash" />
        </button>
      </div>
      <div v-if="showPremiumBanderole" class="premium-banderole premium-banderole--card">
        <span class="premium-banderole__label">premium</span>
      </div>
      <div class="overlay position-absolute d-flex flex-column justify-content-evenly px-4" v-if="hovered && editMode">
        <router-link :to="{name: 'media.edit', params: {asset_id: asset.id}}" class="btn btn-warning">Details / Bearbeiten</router-link>
        <button class="btn btn-outline-danger" @click="deleteAsset"><Icon icon="fa-pro-solid:trash" class="me-2"/>Löschen</button>
      </div>
      <template v-if="asset.content_type === 'application/pdf'">
        <div class="pdf-wrapper position-relative h-100">
          <Icon icon="fa-pro-solid:file-pdf" class="position-absolute pdf-icon" />
          <VuePdfEmbed :page="1" :height="200" :source="asset.auto_url" />
        </div>
      </template>
      <template v-else>
        <div class="img-preview d-flex flex-column justify-content-center">
          <img :alt="asset.alt_text" class="img-fluid" :src="asset.thumbnail_url" />
        </div>
      </template>
    </div>
    <div v-if="editMode">
      {{ asset.alt_text }}
    </div>
  </div>
</template>

<script>

import VuePdfEmbed from "vue-pdf-embed";

export default {
  components: {VuePdfEmbed},
  setup() {
  },
  props: {
    asset: {
      type: Object,
      default: () => null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    hovered: {
      type: Boolean,
      default: false,
    },
    removable: {
      type: Boolean,
      default: false,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    showPremiumBanderole: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    deleteAsset() {
      this.$emit('delete', this.asset.id)
    },
    editAsset() {
      this.$emit('edit', this.asset)
    },
    unlinkAsset() {
      this.$emit('unlink', this.asset.id)
    },
  }
};
</script>

<style lang="scss">

.media-card {
  min-width: 0;

  .media-card__assignment-actions {
    position: absolute;
    bottom: 0.65rem;
    right: 0.65rem;
    left: 0.65rem;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    pointer-events: none;
  }

  .media-card__assignment-action {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    padding: 0;
    border: 1px solid rgba(21, 56, 79, 0.18);
    border-top: 3px solid transparent;
    background: rgba(255, 255, 255, 0.94);
    color: #29465e;
    box-shadow: 0 3px 10px rgba(11, 39, 58, 0.2);
    pointer-events: auto;
    backdrop-filter: blur(4px);
    transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease;

    > svg {
      font-size: 1rem;
    }

    &:focus-visible {
      outline: 2px solid #1b6c97;
      outline-offset: 2px;
    }

    &:hover {
      transform: translateY(-1px);
    }
  }

  .media-card__assignment-action--drag {
    margin-right: auto;
    border-top-color: #1b6c97;
    cursor: grab;

    &:hover {
      background: #eaf3f8;
      color: #08527a;
    }

    &:active {
      cursor: grabbing;
    }
  }

  .media-card__assignment-action--edit {
    border-top-color: #1b6c97;
    cursor: pointer;

    &:hover {
      background: #eaf3f8;
      color: #08527a;
    }
  }

  .media-card__assignment-action--remove {
    border-top-color: #d26464;
    color: #9f3f3f;
    cursor: pointer;

    &:hover {
      background: #fff0f0;
      color: #842f2f;
    }
  }

  .selected-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    font-size: 4rem;
    z-index: 1;
  }
  &.media-card--premium .img-container {
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: rgba(248, 249, 250, 0.45);
      pointer-events: none;
      z-index: 1;
    }

    .img-preview img,
    .pdf-wrapper {
      filter: grayscale(1);
      opacity: 0.5;
    }
  }

  .img-container {
    flex: 0 0 auto;
    width: 100%;
    aspect-ratio: 16 / 9;
    overflow: hidden;
    background: #e5edf2;

    .overlay {
      width: 100%;
      height: 100%;
      top: 0;
      left:0;
      background: rgba(0,0,0,0.3);
      z-index: 2;
    }
  }

  .img-preview,
  .pdf-wrapper {
    width: 100%;
    height: 100%;
  }

  .img-preview img {
    display: block;
    width: 100%;
    height: 100%;
    max-width: none;
    object-fit: cover;
  }

  .pdf-wrapper {
    background-color: #E5E5E5;
    overflow: hidden;

    .vue-pdf-embed {
      height: 100%;

      .vue-pdf-embed__page {
        display: flex;
        justify-content: center;
      }
    }
    .pdf-icon {
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
      text-align: center;
      z-index: 1;
      color: red;
      font-size: 40px;
      opacity: 0.3;
      top: 45%;
    }
  }
}

</style>
